
Greenmile.Checks = Greenmile.Checks || {};
Greenmile.Checks.EventCheck = Greenmile.Checks.EventCheck || {};

Greenmile.Checks.EventCheck.StopRedelivery = {

  template() {
    return {
      items: [{
        attributes: {
          "id": 'StopRedeliveryEvent'
        },
        items: [
          {
            attributes: {
              class: 'control-group',
              id: 'redeliveryReasonsContainer'
            }
          },
          {
            items: [
              {
                attributes: {
                  class: 'control-group',
                  id: 'timesRedeliveredContainer'
                }
              },
              {
                attributes: {
                  class: 'control-group',
                  id: 'plannedSizeContainer'
                }
              },
              {
                attributes: {
                  class: 'control-group',
                  id: 'minimumPlannedSizeContainer'
                }
              }
            ]
          }
        ]
      }]
    };
  },

  renderFields() {
    //Create Monet fields
    const redeliveryReasons = new Monet.UI.Fields.Render({
      name: 'redeliveryReasons',
      label: 'event.stopRedelivery.reasons',
      mandatory: false,
      type: 'LOOKUP_LIST',
      lookupEntity: 'UndeliverableCode',
      lookupEntityColumn: 'description'
    }, 'Event').render();

    redeliveryReasons.customCriteriaChain = [{
      attr: "type",
      neq: "U"
    }];

    const timesRedelivered = new Monet.UI.Fields.Render({
      name: 'timesRedelivered',
      label: 'event.stopRedelivery.timesRedelivered',
      mandatory: false,
      type: 'INTEGER',
    }).render();

    const plannedSize = new Monet.UI.Fields.Render({
      name: 'plannedSize',
      label: 'event.stopRedelivery.plannedSize',
      mandatory: false,
      defaultValue: '',
      type: 'PICKLIST',
      fieldDomains: [
        { description: '', value: '' },
        { description: Monet.Session.Configurations.size1Alias, value: 'plannedSize1', id: 'plannedSize1' },
        { description: Monet.Session.Configurations.size2Alias, value: 'plannedSize2', id: 'plannedSize2' },
        { description: Monet.Session.Configurations.size3Alias, value: 'plannedSize3', id: 'plannedSize3' }
      ]
    }).render();

    const minimumPlannedSize = new Monet.UI.Fields.Render({
      name: 'minimumPlannedSize',
      label: Monet.I18n.getResourcesByKey('event.stopRedelivery.minimumPlannedSize', ' '),
      mandatory: false,
      defaultValue: '0.00',
      type: 'DECIMAL',
    }).render();

    minimumPlannedSize.disable();

    minimumPlannedSize.updateField = () => {
      let selectedSize = plannedSize.input.selectedOptions[0].innerText;
      if (selectedSize) {
        selectedSize = `(${selectedSize})`;
        minimumPlannedSize.enable();
      } else {
        selectedSize = ' ';
        minimumPlannedSize.disable();
      }
      minimumPlannedSize.setTextLabel(Monet.I18n.getResourcesByKey('event.stopRedelivery.minimumPlannedSize', selectedSize));
    }

    plannedSize.removeOption(0);
    plannedSize.input.addEventListener('change', minimumPlannedSize.updateField);

    Greenmile.Checks.EventCheck.StopRedelivery.fields = { redeliveryReasons, timesRedelivered, plannedSize, minimumPlannedSize };

    //Append fields to DOM  
    const redeliveryReasonsContainer = document.querySelector('#StopRedeliveryEvent #redeliveryReasonsContainer');
    redeliveryReasonsContainer.appendChild(redeliveryReasons.rootEl);

    const timesRedeliveredContainer = document.querySelector('#StopRedeliveryEvent #timesRedeliveredContainer');
    timesRedeliveredContainer.appendChild(timesRedelivered.rootEl);

    const plannedSizeContainer = document.querySelector('#StopRedeliveryEvent #plannedSizeContainer');
    plannedSizeContainer.appendChild(plannedSize.rootEl);
    const minimumPlannedSizeContainer = document.querySelector('#StopRedeliveryEvent #minimumPlannedSizeContainer');
    minimumPlannedSizeContainer.appendChild(minimumPlannedSize.rootEl);
  },

  assignParameter(jsonParam) {
    Greenmile.Checks.EventCheck.StopRedelivery.renderFields();
    const fields = Greenmile.Checks.EventCheck.StopRedelivery.fields;
    if (jsonParam) {
      jsonParam = JSON.parse(jsonParam);
      fields.redeliveryReasons.setValue(jsonParam.reasons);
      fields.timesRedelivered.setValue(jsonParam.redeliveryTimes);
      if (jsonParam.minimumPlanned) {
        const plannedSize = Object.keys(jsonParam.minimumPlanned)[0];
        fields.plannedSize.setValue(plannedSize);
        fields.minimumPlannedSize.setValue(jsonParam.minimumPlanned[plannedSize]);
        fields.minimumPlannedSize.updateField();
      }
    }
  },

  retrieveParameter() {
    const fields = Greenmile.Checks.EventCheck.StopRedelivery.fields;
    let minimumPlanned = null;
    if (fields.plannedSize.getValue()) {
      minimumPlanned = { [fields.plannedSize.getValue()]: fields.minimumPlannedSize.getValue() }
    }
    return JSON.stringify({
      reasons: fields.redeliveryReasons.getFullValue().map(field => field.id),
      redeliveryTimes: fields.timesRedelivered.getValue(),
      minimumPlanned
    });
  }

};